import { render, staticRenderFns } from "./WarehouseLocationEdit.vue?vue&type=template&id=b84bcec8&"
import script from "./WarehouseLocationEdit.vue?vue&type=script&lang=js&"
export * from "./WarehouseLocationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports